module.exports = __webpack_public_path__ + "static/assets/374b528253b1aeb85cfb22503f8aa214.svg";